import types from './types'

export const initialState = {
  error: null,
  isInitialized: false,
  isLoading: false,
  netSuiteAssets: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCHING_NETSUITE_ASSETS_ME:
    case types.FETCHING_NETSUITE_ASSETS_ME_SUCCESS:
    case types.FETCHING_NETSUITE_ASSETS_ME_ERROR:
      return {
        ...state,
        error:
          action.type === types.FETCHING_NETSUITE_ASSETS_ME_ERROR
            ? action.error
            : null,
        isInitialized:
          action.type === types.FETCHING_NETSUITE_ASSETS_ME_SUCCESS ||
          action.type === types.FETCHING_NETSUITE_ASSETS_ME_ERROR ||
          state.isInitialized,
        isLoading: action.type === types.FETCHING_NETSUITE_ASSETS_ME,
        netSuiteAssets:
          action.type === types.FETCHING_NETSUITE_ASSETS_ME_SUCCESS
            ? action.netSuiteAssets
            : state.netSuiteAssets,
      }
    case types.FETCHING_NETSUITE_ASSETS:
    case types.FETCHING_NETSUITE_ASSETS_SUCCESS:
    case types.FETCHING_NETSUITE_ASSETS_ERROR:
      return {
        ...state,
        error:
          action.type === types.FETCHING_NETSUITE_ASSETS_ERROR
            ? action.error
            : null,
        isLoading: action.type === types.FETCHING_NETSUITE_ASSETS,
        netSuiteAssets:
          action.type === types.FETCHING_NETSUITE_ASSETS_SUCCESS
            ? action.netSuiteAssets
            : state.netSuiteAssets,
      }

    case types.ASSIGNING_NETSUITE_ASSET:
    case types.ASSIGNING_NETSUITE_ASSET_SUCCESS:
    case types.ASSIGNING_NETSUITE_ASSET_ERROR:
      return {
        ...state,
        error:
          action.type === types.ASSIGNING_NETSUITE_ASSET_ERROR
            ? action.error
            : null,
        isLoading: action.type === types.ASSIGNING_NETSUITE_ASSET,
        netSuiteAssets:
          action.type === types.ASSIGNING_NETSUITE_ASSET_SUCCESS
            ? [
                ...state.netSuiteAssets.map(asset =>
                  asset.id === action.netSuiteAsset.id
                    ? action.netSuiteAsset
                    : asset,
                ),
              ]
            : state.netSuiteAssets,
      }
    default:
      return state
  }
}
